import { Property } from "./types";

export const FETCHED_ALL_ACTION = "fetchedAll";
export const DELETED_ACTION = "deleted";
export const ADDED_ACTION = "added";
export const EDITED_ACTION = "edited";

interface FetchedAllAction {
  type: typeof FETCHED_ALL_ACTION;
  payload: {
    properties: Property[];
  };
}

interface DeletedAction {
  type: typeof DELETED_ACTION;
  payload: {
    id: string;
  };
}

interface AddedAction {
  type: typeof ADDED_ACTION;
  payload: {
    property: Property;
  };
}

interface EditedAction {
  type: typeof EDITED_ACTION;
  payload: {
    property: Property;
  };
}

export type Action =
  | FetchedAllAction
  | DeletedAction
  | AddedAction
  | EditedAction;
